import { render, staticRenderFns } from "./sag.vue?vue&type=template&id=f2dd965a&"
import script from "./sag.vue?vue&type=script&lang=js&"
export * from "./sag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports